var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4899 6.02174C15.1155 6.01831 14.7348 6.00917 14.35 5.99993C13.2995 5.97471 12.219 5.94877 11.1574 6.03648L11.1565 6.03655C8.6064 6.25156 6.69755 8.06643 6.56655 10.6442L6.56652 10.6447C6.42229 13.5439 6.42229 16.4561 6.56652 19.3553L6.56654 19.3557C6.69676 21.9326 8.59528 23.8341 11.1601 23.9646L11.1606 23.9646C14.0583 24.1089 16.969 24.1089 19.8538 23.9646L19.8542 23.9646C22.4161 23.8342 24.3304 21.9355 24.4608 19.3689L24.4608 19.3682C24.6051 16.4547 24.5919 13.517 24.4609 10.6079L24.4609 10.6071C24.3441 8.10861 22.4111 6.26614 19.9649 6.06287C18.898 5.95925 17.8078 5.98199 16.7557 6.00392C16.326 6.01288 15.9027 6.02171 15.4899 6.02174ZM1.02148 14.9609C1.02148 6.97003 7.52197 0.5 15.5658 0.5C23.5507 0.5 30.0059 7.0154 30.0059 15.0652C30.0059 23.0408 23.4817 29.4996 15.4363 29.5C7.48911 29.4874 1.02148 22.9708 1.02148 14.9609Z",
    stroke: "url(#paint0_linear_458_1093)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9825 10.0054H20.9824L20.9827 10.0168C20.9893 10.3079 20.748 10.5489 20.4657 10.5489C20.1999 10.5489 19.9293 10.2724 19.9357 10.0043L19.9357 10.004C19.9422 9.72369 20.1885 9.4872 20.4821 9.50055L20.4821 9.50067L20.4929 9.50092C20.7671 9.50746 20.9825 9.72718 20.9825 10.0054Z",
    stroke: "url(#paint1_linear_458_1093)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.523 12.6305C16.8266 12.6412 17.8692 13.6839 17.8692 15C17.8692 16.314 16.8292 17.3577 15.512 17.3696C14.1757 17.3685 13.1232 16.3059 13.1329 14.967C13.1556 13.6627 14.2223 12.6197 15.523 12.6305Z",
    stroke: "url(#paint2_linear_458_1093)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_1093",
    x1: 29.6486,
    y1: -92.8337,
    x2: 8.42466,
    y2: 50.3522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_458_1093",
    x1: 23.5084,
    y1: -37.1629,
    x2: 13.5048,
    y2: 30.2484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_458_1093",
    x1: 18.2052,
    y1: -5.62931,
    x2: 14.145,
    y2: 21.7631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDDBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477083,
    stopColor: "#FFEA9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#693E18"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.caecefd6a4b3ea8ff7af3ec2f02acd87.svg";
export { ForwardRef as ReactComponent };